import React from 'react';
import styled from "styled-components"
import close from "../assets/close.svg";
import sad from "../assets/sad.svg";
import {Close,} from "../views/Staking";
import {Connect} from "./Connect";

const Wrapper = styled.form`
width:300px;
min-height: 500px;
background: #fff;
box-shadow: 0 0 10px -5px #212121;
border-radius: 7px;
position:absolute;
top:100px;
left:50%;
transform: translateX(-50%);
padding:2rem 3rem;
display: ${({isLoginModalOpen}) => isLoginModalOpen ? "flex" : "none"};
flex-direction: column;
margin: 4rem 0;
z-index: 999;

.text {
color:#AB5EB2;
text-align: center;
font-size: 1.7rem;
font-weight: bold;
margin: 1rem 0;
}
h3 {
  color:#AB5EB2;
  text-align: center;
  font-size: 2.5rem;
}


&::before {
content:"Registry with KYC procedure will be active since 02.01.2021 ";
display: flex;
justify-content: center;
align-items: center;
color:#fff;
font-size: 2.8rem;
text-align: center;
padding: 0 1rem;
position:absolute;
left:0;
top:0;
width:100%;
height: 100%;
background: rgba(0,0,0,0.6);
border-radius: 7px;

}
`

const Label = styled.label`
  color:#AB5EB2;
  font-size: 1.8rem;
  margin: 1rem 0  ;
  
`


const StyledInput = styled.input`
border:none;
height: 30px;
border-bottom: 2px solid #d072d8;
color:#AB5EB2;
font-size: 1.5rem;
padding: 0 1rem;
&:focus {
outline: none;
}
`

const SignUpBtn = styled.button`
   width:90%;
  margin:0 auto;
  height: 50px;
  border:none;
  border-radius: 5px;
 background-image: linear-gradient(to right, #9D50BB 0%, #6E48AA  51%, #9D50BB  100%);
 background-size: 200% auto;
 transition: 0.5s;
  font-family: 'PT Sans Narrow', sans-serif;
  color:#fff;
  font-size: 2.5rem;
  margin-top: auto;
  margin-bottom: 1rem;
  
  &:hover {
  cursor: pointer;
    background-position: right center; /* change the direction of the change here */
    text-decoration: none;
  }
   
   &:focus {
   outline: none;
   }
`
const SignUpForm = ({setLoginModalOpen, isLoginModalOpen}) => {

    return (
        <Wrapper isLoginModalOpen={isLoginModalOpen}>
            <Close src={close} onClick={() => setLoginModalOpen(!isLoginModalOpen)}/>
            <h3>Create an Account</h3>
            <Label>Email</Label>
            <StyledInput/>

            <Label>Name</Label>
            <StyledInput/>

            <Label>Surname</Label>
            <StyledInput/>

            <Label>Password</Label>
            <StyledInput/>

            <SignUpBtn>Sign Up</SignUpBtn>
        </Wrapper>
    );
};

export default SignUpForm;